import styled from 'styled-components';

import { grey150, chartDarkGray, brandColors } from 'styles/colors';
import { ApTextInput, ApToggleSwitch } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	position: relative;
	padding-top: 2px;
`;

export const IndexText = styled.div`
	height: 32px;
	line-height: 32px;
	margin: 5px 0px 0 0;
	width: 36px;
	text-align: center;
`;

export const VerticalDivider = styled.div`
	height: 32px;
	width: 0;
	border-right: 1px solid ${grey150};
	margin: 5px 21px 0 20px;
	display: flex;
`;

export const TextInput = styled(ApTextInput)`
	margin: 0 24px 0 0;
	/* TODO: remove this when component is fixed */
	font-size: 16px !important;
`;

export const ToggleSwitch = styled(ApToggleSwitch)`
	margin: 2px 0 0 3px;
`;

export const ListRow = styled.div`
	display: flex;
	height: 40px;
`;

export const HeaderRow = styled(ListRow)`
	height: 16px;
`;

export const HeaderItem = styled.div`
	color: ${chartDarkGray};
	font-size: 11px;
	letter-spacing: 0.8px;
	line-height: 13px;
	text-transform: uppercase;
	font-weight: normal;
	text-align: left;
	width: ${({ width }) => (width ? `${width}px` : 'auto')};
	${({ width }) => (width === 'auto' ? '' : '')};
`;

export const HeaderItemToggle = styled(HeaderItem)`
	width: 95px;
`;

export const HeaderItemName = styled(HeaderItem)`
	width: 244px;
`;

export const HeaderItemOptions = styled(HeaderItem)`
	flex: 1;
`;

export const ListToggleWrapper = styled.div`
	width: 60px;
	min-width: 60px;
	display: flex;

	/* TODO: remove this when component is fixed */
	input:checked + span,
	input:checked + span::before {
		border-color: ${brandColors.green} !important;
	}
	input:checked + span::before {
		background-color: ${brandColors.green} !important;
		transform: translateX(12px) !important;
	}
`;
export const ListNameWrapper = styled.div`
	width: 244px;
	min-width: 244px;
	display: flex;
`;

export const ListOptionsWrapper = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
`;

export const OptionsText = styled.div`
	color: ${chartDarkGray};
	font-size: 16px;
	font-weight: bold;
	letter-spacing: 0.3px;
	height: 40px;
	line-height: 40px;
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
